import { FC } from 'react'
import shallow from 'zustand/shallow'
import { EmployeesView } from './EmployeesView'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { useCompanySettingsStore } from '../CompanySettingsStore'
import { useCompanySettingsEmployees } from '../../../graphql/companySettings/useCompanySettingsEmployees'

export const CompanySettingsEmployeesTab: FC = () => {
  const [selected] = useCompanySettingsStore((state) => [state.selected], shallow)

  const { data, error, loading } = useCompanySettingsEmployees(selected.companyId)

  if (loading || error || !data || !data.subordinateOfCompany || !data.resignedEmployeesOfCompany || !data.employeeLevels) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data} error={error} showSpinner />
  } else {
    return (
      <EmployeesView
        initialActiveEmployeesData={data.subordinateOfCompany}
        resignedEmployeesData={data.resignedEmployeesOfCompany.resignedEmployees}
        employeeLevels={data.employeeLevels}
        companyId={selected.companyId}
        employeesWithWrongStatusOrMissingContract={data.resignedEmployeesOfCompany.employeesWithWrongStatusOrMissingContractDTO}
      />
    )
  }
}
